import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageTitleFromPath } from '../../utils/pageTitles';

/**
 * Sets document.title from the current route. Mount once inside BrowserRouter.
 * Pages may still override the title (e.g. project name) after data loads.
 */
export default function DocumentTitleSync() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = getPageTitleFromPath(pathname);
  }, [pathname]);

  return null;
}
